import { render, staticRenderFns } from "./EditText.vue?vue&type=template&id=2e11638a"
import script from "./EditText.vue?vue&type=script&lang=js"
export * from "./EditText.vue?vue&type=script&lang=js"
import style0 from "./EditText.vue?vue&type=style&index=0&id=2e11638a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports